import { gatewayClient, createService } from './connectors/httpClient';

const httpClient = gatewayClient('/fonts/customer/');

const fontsService = createService(httpClient, (client) => ({
    getFonts(customerId: number) {
        return client.get(`${customerId}/fonts`);
    },
}));

export default fontsService;
